import React from 'react';
import styled from 'styled-components';

const AboutSection = styled.section`
  background-color: #0c0c14;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, var(--primary), var(--secondary));
    opacity: 0.7;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const AboutContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const AboutText = styled.div`
  @media (max-width: 768px) {
    order: 2;
  }
`;

const AboutImageContainer = styled.div`
  position: relative;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  overflow: hidden;
  
  @media (max-width: 768px) {
    order: 1;
  }
`;

const AboutImage = styled.div`
  width: 100%;
  background: linear-gradient(135deg, #1e1e30, #2c2c44);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: 'Orbitron', sans-serif;
  font-size: 1.2rem;
  color: var(--secondary);
  text-align: center;
  padding: 1rem;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  color: var(--secondary);
  position: relative;
  padding-bottom: 1rem;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 80px;
    height: 4px;
    background: linear-gradient(90deg, var(--primary), var(--secondary));
    border-radius: 2px;
  }
`;

const Paragraph = styled.p`
  margin-bottom: 1.5rem;
  line-height: 1.8;
  color: var(--text-secondary);
  font-size: 1.1rem;
`;

const About = () => {
  return (
    <AboutSection id="about">
      <Container>
        <AboutContent>
          <AboutText>
            <Title>About RIFT: Last One</Title>
            <Paragraph>
              RIFT: Last One is an AI-driven observational strategy survival game that offers a unique approach to gaming. Instead of directly controlling characters, you assume the role of a multidimensional "God" who provides guidance through "revelations."
            </Paragraph>
            <Paragraph>
              In this apocalyptic world, AI characters make their own decisions based on the revelations you provide, creating truly emergent and unpredictable gameplay experiences. Your guidance shapes their actions, but their decisions and the consequences are autonomous.
            </Paragraph>
            <Paragraph>
              The combination of advanced AI, strategic elements, and the observational approach makes RIFT: Last One a groundbreaking entry in the survival game genre, challenging traditional notions of player control and agency.
            </Paragraph>
          </AboutText>
          <AboutImageContainer>
            <AboutImage>
              <img src="/images/screenshot-20250318-131303.png" alt="Game Screenshot" style={{width: '100%', maxHeight: '300px', objectFit: 'contain', marginBottom: '1rem'}} />
              Multidimensional gameplay with advanced AI
            </AboutImage>
          </AboutImageContainer>
        </AboutContent>
      </Container>
    </AboutSection>
  );
};

export default About;
